import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import AxiosService from "../../services/AxiosHelper";

const baseURL = process.env.REACT_APP_BASEURL;

export const getTaxList = createAsyncThunk(
    "tax/getTaxList",
    async (businessId, { rejectWithValue }) => {
        try {
            const response = await AxiosService.AxiostRequest({
                url: baseURL + `/tax` + (businessId ? `?businessId=${businessId}` : ""),
                method: "get",
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to fetch taxes");
        }
    }
);

export const addTax = createAsyncThunk(
    "tax/addTax",
    async (values, { rejectWithValue }) => {
        try {
            const response = await AxiosService.AxiostRequest({
                method: "post",
                url: baseURL + `/tax`,
                data: values,
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to add tax");
        }
    }
);

export const updateTax = createAsyncThunk(
    "tax/updateTax",
    async (values, { rejectWithValue }) => {
        try {
            const response = await AxiosService.AxiostRequest({
                method: "put",
                url: baseURL + `/tax/${values.id}`,
                data: values,
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Update failed");
        }
    }
);

export const deleteTax = createAsyncThunk(
    "tax/deleteTax",
    async (id, { rejectWithValue }) => {
        try {
            await AxiosService.AxiostRequest({
                method: "delete",
                url: baseURL + `/tax/${id}`,
            });
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to delete tax");
        }
    }
);

const taxSlice = createSlice({
    name: "tax",
    initialState: {
        taxList: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTaxList.fulfilled, (state, action) => {
            state.taxList = action.payload || [];
            state.loading = false;
        });
        builder.addCase(addTax.fulfilled, (state, action) => {
            state.taxList.unshift(action.payload);
            state.loading = false;
            toast.success("Tax added successfully");
        });
        builder.addCase(updateTax.fulfilled, (state, { payload }) => {
            state.taxList = state.taxList.map((tax) =>
                tax._id === payload._id ? payload : tax
            );
            state.loading = false;
            toast.success("Tax updated successfully");
        });
        builder.addCase(deleteTax.fulfilled, (state, action) => {
            state.taxList = state.taxList.filter((tax) => tax._id !== action.payload);
            state.loading = false;
            toast.success("Tax deleted successfully");
        });

        // General Matchers
        builder.addMatcher(
            (action) => action.type.startsWith("tax/") && action.type.endsWith("/pending"),
            (state) => { state.loading = true; }
        );
        builder.addMatcher(
            (action) => action.type.startsWith("tax/") && (action.type.endsWith("/fulfilled") || action.type.endsWith("/rejected")),
            (state, action) => {
                state.loading = false;
                if (action.type.endsWith("/rejected")) {
                    toast.error(action.payload?.message || "Something went wrong");
                }
            }
        );
    },
});

export default taxSlice.reducer;
